import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=7171d6dd&"
import script from "./SearchProducts.vue?vue&type=script&lang=js&"
export * from "./SearchProducts.vue?vue&type=script&lang=js&"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=7171d6dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports